import { Component, OnInit, Injector } from "@angular/core";
import { FormGroup, FormBuilder, FormControl } from "@angular/forms";
import { Router } from "@angular/router";
import { NgSelectModule, NgOption } from "@ng-select/ng-select";
import { request } from "http";
import { ToastrService } from "ngx-toastr";
import { HttpClient } from "@angular/common/http";
import { SharedStateService } from "src/app/shared-utility/services/shared-state.service";
import { SharedFormService } from "src/app/shared-utility/services/shared-form.service";
import { NumberFormatStyle } from "@angular/common";
@Component({
  selector: "app-security-questions",
  templateUrl: "./security-questions.component.html",
  styleUrls: ["./security-questions.component.scss"],
})
export class SecurityQuestionsComponent implements OnInit {
  
  public payload;
  public firstQuestion: string;
  public secondQuestion: string;
  public thirdQuestion: string;
  private toastr: ToastrService;
  public firstField: boolean=false;
  public secondField: boolean=false;
  public thirdField: boolean=false;
  public firstAnswer = "";
  public secondAnswer = "";
  public thirdAnswer = "";
  public currentpassword = "";
  public check: boolean;
  public currentPasswordShowPasswordIcon:boolean = false;


  public userForm: FormGroup;
 
  public selectedQuestions = {
    firstQuestionId: null,
    secondQuestionId: null,
    thirdQuestionId: null,
  };

  securityQuestions: any[] = [];
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private http: HttpClient,
    private sharedStateSvc: SharedStateService,
    private formData: SharedFormService,
    private toaster: ToastrService
  ) {
    if (!localStorage.getItem("jwt")) {
      this.router.navigate(["/login"]);
    }
  }

  ngOnInit() {
    const user = localStorage.getItem('username');

    if(localStorage.getItem("HasSecurityQuestionAnswered")=="true"){
      this.router.navigate(["/dashboard"]);
    }
    this.sharedStateSvc
    .getAccountInfo(user)
    .subscribe(
      (resp) => {
        this.sharedStateSvc.PrimaryState.prescriberInfo.portalAccountPkId = resp.Payload.PortalAccountPkId;
       
      },
      (error) => {
        this.formData.hideLoader.next(false);
        
          this.toastr.error("There was an error accessing account information!");
      
        this.router.navigate(["/login"]);
      }
    );
    this.formData.hideLoader.next(true);
    this.sharedStateSvc.getSecurityQuestions().subscribe((resp)=>{
      this.securityQuestions = resp.Payload;
    this.formData.hideLoader.next(false);

    },
    (error)=>{
    this.formData.hideLoader.next(false);
      

    });
  }
  toggleCurrentPassword(){
    this.currentPasswordShowPasswordIcon = !this.currentPasswordShowPasswordIcon;
  }

  uniqueSecurityQuestion(key){
    if(key == 0) {
      return this.securityQuestions.filter((item)=> item.Id != this.selectedQuestions.secondQuestionId && item.Id != this.selectedQuestions.thirdQuestionId)
    }
    if(key == 1) {
      return this.securityQuestions.filter((item)=> item.Id != this.selectedQuestions.firstQuestionId && item.Id != this.selectedQuestions.thirdQuestionId)
    }
    else if(key == 2) {
      return this.securityQuestions.filter((item)=> item.Id != this.selectedQuestions.firstQuestionId && item.Id != this.selectedQuestions.secondQuestionId)
    }
  }
  change(question: string, id: number) {
    if (question == "firstQuestionId") {
      this.firstAnswer="";
      this.selectedQuestions.firstQuestionId = id;
    }
    if (question == "secondQuestionId") {
      this.selectedQuestions.secondQuestionId = id;
      this.secondAnswer="";
    }
    if (question == "thirdQuestionId") {
      this.thirdAnswer="";
      this.selectedQuestions.thirdQuestionId = id;
    }
  }

  submit() {

    this.payload = {
      CurrentPassword: this.currentpassword,
      SecurityAnswers:[
      { PortalAccountId:this.sharedStateSvc.PrimaryState.prescriberInfo.portalAccountPkId, SecurityQuestion:{Id:+this.selectedQuestions.firstQuestionId},Choice:null,Answer:this.firstAnswer},
      { PortalAccountId:this.sharedStateSvc.PrimaryState.prescriberInfo.portalAccountPkId, SecurityQuestion:{Id:+this.selectedQuestions.secondQuestionId},Choice:null,Answer:this.secondAnswer },
      { PortalAccountId:this.sharedStateSvc.PrimaryState.prescriberInfo.portalAccountPkId, SecurityQuestion:{Id:+this.selectedQuestions.thirdQuestionId},Choice:null,Answer:this.thirdAnswer},
    ]};
    

    this.sharedStateSvc.sendQuestions(this.payload).subscribe(
      (result) => {
           if(result.Status === 'SUCCESS'){
            localStorage.setItem("HasSecurityQuestionAnswered", "true")
            this.toaster.success("Your Security Questions have been Saved successfully.");
            this.router.navigate(["/dashboard"]);
           } else {
             this.toaster.error("Something went wrong");
           }
          
         },
      (error) => {
          this.toaster.error("The supplied Password is incorrect,Security Questions are not Saved");
        console.warn(error);
      }
    );

  }
  checkFields(answerField: string){
    if( answerField == 'firstAnswer'){
      this.firstAnswer = this.firstAnswer.toString().trim();
      if (!this.firstAnswer ) {
        this.firstField = true;
      } else {
        this.firstField = false;
      }
      
    }
    if( answerField == 'secondAnswer'){
      this.secondAnswer = this.secondAnswer.toString().trim();
      if( !this.secondAnswer ){
        this.secondField = true;
      } else {
        this.secondField = false;
      }
    }
    if( answerField == 'thirdAnswer'){
     
      this.thirdAnswer = this.thirdAnswer.toString().trim();
      if (!this.thirdAnswer ) {
        this.thirdField = true;
      } else {
        this.thirdField = false;
      }
    }
  }

 
}
